import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.70711 2.29289C2.31658 1.90237 1.68342 1.90237 1.29289 2.29289C0.902369 2.68342 0.902369 3.31658 1.29289 3.70711L11.2929 13.7071C11.6834 14.0976 12.3166 14.0976 12.7071 13.7071L22.7071 3.70711C23.0976 3.31658 23.0976 2.68342 22.7071 2.29289C22.3166 1.90237 21.6834 1.90237 21.2929 2.29289L12 11.5858L2.70711 2.29289Z M2 19C1.44772 19 1 19.4477 1 20C1 20.5523 1.44772 21 2 21L22 21C22.5523 21 23 20.5523 23 20C23 19.4477 22.5523 19 22 19L2 19Z"
  }));
});
var NavigationChevronBottom = AbstractIcon.withComponent(Icon);
NavigationChevronBottom.displayName = 'NavigationChevronBottom';
export default NavigationChevronBottom;